import React from "react";
import "./AtencionSinTurno.css";

const AtencionSinTurnoTituloTxt = () => {
    return (
        <React.Fragment>
            <div className="ptur-atencionSinTurno-textoInicial">
                <p className="rb24b">Prestamos atención sin turno en estos Centros de DIM</p>
                <p className="rb18l">Tené en cuenta que el horario de finalización del servicio de clínica médica puede variar dependiendo de la cantidad de pacientes que haya en espera.</p>
            </div>
        </React.Fragment>
    );
}
 
export default AtencionSinTurnoTituloTxt;